import { Link } from 'react-router-dom';
import { lmsLineItemsPriority } from '../../../../constants';
import useFetchManifestLegItems from '../../../../hooks/useFetchManifestLegItems';
import { lmsStatusChips } from '../../../../utils/utils';
import CheckIcon from '../../../global-components/checkIcon';
import NoDataFound from '../../../global-components/no-data-found';

type Props = {
  manifestNo: string;
  manifestLegNumber: number | null;
};

const ManifestItemsTable = ({ manifestNo, manifestLegNumber }: Props) => {
  const { data, isLoading } = useFetchManifestLegItems({
    manifestNo,
    manifestLegNumber,
  });
  const hasData = !!data && !!data?.length;

  function getPriorityLabel(value: any) {
    const priority = lmsLineItemsPriority.find((p) => p.value === value);
    return priority ? priority.label : value;
  }

  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>Items</h5>
      </div>
      <div className='card-body p-2 h-auto'>
        <table className='table' id='lmn-manifest-items-table'>
          <thead className='ubbe-table-header'>
            <tr>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Barcode
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Quantity
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Accepted Date
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Camp Container
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Yard Location
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Priority
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Weight (lbs)
              </th>
              <th className={`text-center ubbe-table-heading-text`} scope='col'>
                Loaded
              </th>
              <th className={`text-center ubbe-table-heading-text`} scope='col'>
                DG
              </th>
            </tr>
          </thead>
          <tbody id='set_lanes_rows' className='bg-white'>
            {!isLoading &&
              hasData &&
              data?.map((item: any) => (
                <tr key={item.no}>
                  <td className='align-middle'>
                           <Link
                              className="text-decoration-none"
                              to={`/app/warehouse/items/view?item_no=${item["item_no"]}&barcode=${item["no"]}`}
                            >
                               <u
                                className="labelText"
                                style={{ color: "#251163", fontSize: "16px" }}
                              >
                                {item.no || 'N/A'}
                              </u>
                            </Link>
                     </td>
                  <td className='align-middle'>
                    {item.manifest_item_quantity || 'N/A'}
                  </td>
                  <td className='align-middle'>
                    {item.manifest_item_accepted_date || 'N/A'}
                  </td>
                  <td className='align-middle'>
                    {item.manifest_item_camp_container || 'N/A'}
                  </td>
                  <td className='align-middle text-break '>
                    {item.manifest_item_yard_location || 'N/A'}
                  </td>
                  <td className='align-middle'>
                    {item?.manifest_item_priority
                      ? lmsStatusChips(
                          getPriorityLabel(item?.manifest_item_priority)
                        )
                      : 'N/A'}
                  </td>
                  <td className='align-middle'>{item.weight || 'N/A'}</td>
                  <td className='align-middle'>
                    <CheckIcon checked={item.loaded} />
                  </td>
                  <td className='align-middle'>
                    <CheckIcon checked={!!item.dangerous_goods_check} />
                  </td>
                </tr>
              ))}
            {!isLoading && !hasData && (
              <tr>
                <td colSpan={9}>
                  <NoDataFound />
                </td>
              </tr>
            )}
            {isLoading && (
              <tr>
                <td colSpan={9}>
                  <div className='spinner-border' role='status'>
                    <span className='visually-hidden'></span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManifestItemsTable;
